module.exports = __webpack_public_path__ + "img/page_left_bg.de0ecdcf.png";